import { Suspense, useEffect, useState } from "react";
import PropTypes from "prop-types";
import SideItem from "./SideItem/SideItem";
import stylesModule from "./SideBar.module.sass";
import useContainerResize from "../../../hooks/useContainerResize";
import { useDispatch, useSelector } from "react-redux";
import {
  handleChangeOmitPart,
  handleChangePart,
  stopWorkingWorkstation
} from "../../../redux/dashboard/dashboardSlice";
import { useNavigate } from "react-router-dom";
import { ModalError } from "../../Modals/Modals";
import handlePathsByTypeWorkstations from "./helpers/handlePathsByTypeWorkstations";
import { useTranslation } from "react-i18next";
import { supportedLngs } from "../../../utils/ConstCapture";

const SideBar = props => {
  const { options = [] } = props;
  const [modal, setModal] = useState(null);
  const containerWidth = useContainerResize("logo-header");
  const dispatch = useDispatch();
  const { errors, workstationSelected, omitPart, company } = useSelector(
    state => ({
      errors: state.dashboard.errorsStopWorking,
      workstationSelected: state.dashboard.workstationSelected,
      omitPart: state.dashboard.omitPart,
      company: state.userData.company
    })
  );

  const navigate = useNavigate();
  const path = window.location.pathname.split("/");
  const pathLanguage = supportedLngs.includes(path[1]) ? path[1] : "es";
  const { t } = useTranslation("general");

  const handleSelecOption = async ({ path }) => {
    if (
      path ===
      handlePathsByTypeWorkstations(
        workstationSelected,
        "workstations",
        company?.id
      )
    ) {
      await dispatch(stopWorkingWorkstation());
      if (omitPart) {
        dispatch(handleChangeOmitPart(false));
      }
    } else if (
      path ===
      handlePathsByTypeWorkstations(
        workstationSelected,
        "select-parts",
        company?.id
      )
    ) {
      if (omitPart) {
        dispatch(handleChangeOmitPart(false));
      } else {
        dispatch(handleChangePart(true));
      }
    } else {
      navigate(`/${pathLanguage}/${path}`);
    }
  };

  useEffect(() => {
    if (errors.length > 0) {
      setModal(<ModalError unmount={() => setModal(null)} messages={errors} />);
    }
  }, [errors]);

  return (
    <aside
      className={stylesModule.sideBar}
      style={{ width: `${containerWidth + 3}px` }}
    >
      {modal}
      <nav>
        {options.map(option => {
          const path = handlePathsByTypeWorkstations(
            workstationSelected,
            option.key,
            company?.id
          );
          return (
            <SideItem
              key={path}
              id={path}
              path={`/${pathLanguage}/${path}`}
              icon={option.icon}
              label={
                <Suspense fallback={"Cargando..."}>{t(option.label)}</Suspense>
              }
              onClick={() => handleSelecOption({ path: path })}
            />
          );
        })}
      </nav>
    </aside>
  );
};

SideBar.propTypes = {
  options: PropTypes.array
};

export default SideBar;
